'use strict';

angular.module('app')
  .service('Booking', function (checkoutDrService, checkoutService, Request, Search, Auth) {
    var booking = {}, isAffiliate = Auth.isAffiliate() || null;

    booking.getList = function (params) {
      return Request.get('account/bookings/', params).then(function (res) {
        if (params && params.is_past) {
          _.each(res.data.results, function (val) {
            val.isPast = true;
          });
        }
        return res.data;
      });
    };

    booking.getOrder = function (id) {
      return Request.get('account/bookings/' + id + '/', {is_affiliate: isAffiliate}).then(function (res) {
        var data = res.data;
        if (data.dateTo) {
          // determine past orders by comparing dates;
          data.isPast = moment().utc().endOf('day') > moment(data.dateTo).utc().endOf('day');
        }

        if (data.rooms || data.cabinOverview) {
          data.divesInfo = data.dives.reduce(function (i, val) {
            return {
              totalDives: i.totalDives + +val.numberOfInstances,
              amount: i.amount + +val.amount,
            };
          }, { totalDives: 0, amount: 0 });

          data.totalPackagePrice = 0;
          data.itemsExtraTotal = 0;
          data.itemsMandatoryTotal = 0;

          data.itemsIncluded = [];
          data.itemsMandatory = [];
          data.itemsExtra = [];
          data.itemsIncludedNonDiver = [];
          data.itemsIncludedStudent = [];
          data.itemsIncludedDiver = [];
          data.freeInsurance = [];

          _.each(data.extras, function (val) {
            if (val.isIncluded) {
              val = checkoutDrService.setCourseType(val);
              if (data.shopKind === 10) {
                if (val.isLiveaboardDiverItem) {
                  data.itemsIncludedDiver.push(val);
                } else {
                  data.itemsIncludedNonDiver.push(val);
                }
              } else {
                data.itemsIncluded.push(val);
              }
            } else if (val.isMandatory) {
              data.itemsMandatory.push(val);

              if (val.payedInAdvance) {
                data.itemsMandatoryTotal += +val.amount;
              }
            } else {
              data.itemsExtra.push(val);

              if (val.payedInAdvance) {
                data.itemsExtraTotal += +val.amount;
              }
            }
          });

          _.each(data.courses, function (val) {
            if (val.guestType === 40) {
              data.itemsIncludedStudent.push(val);
              data.totalPackagePrice += +val.amount;
            } else {
              data.itemsExtra.push({
                amount: val.amount,
                payedInAdvance: true,
                quantity: val.quantity,
                price: val.amount / val.quantity,
                title: val.title,
                isCourse: true,
              });
              data.itemsExtraTotal += +val.amount;
            }
          });

          data.totalForOptions = 0;

          _.each(data.options, function (val) {
            if (+val.kind === 20) {
              data.totalForOptions -= val.absoluteValue;
            } else {
              data.totalForOptions += val.absoluteValue;
            }
          });

          _.each(data.insurances, function (val) {
            val.isInsurance = true;
            if (val.isIncludedInPrice) {
              data.freeInsurance.push(val);
            } else {
              data.itemsExtra.push({
                title: val.title,
                quantity: val.quantity,
                price: val.price,
                isIncurance: true,
                payedInAdvance: true,
                amount: val.quantity * +val.price,
              });

              data.itemsExtraTotal += +val.quantity * +val.price;
            }
          });

          data.totalPackagePrice += data.rooms && +data.rooms.amount + data.divesInfo.amount;
        }

        return data;
      });
    };


    booking.getPrices = function (uuid) {
      return Request.get('account/bookings/' + uuid + '/prices/', {is_affiliate: isAffiliate}).then(function (res) {
        res.data.singleOccupancy = [];
        _.each(res.data.itemsOverview, function (val) {
          if (val.singleSurcharge !== null) {
            res.data.singleOccupancy.push(val);
          }
        });

        return res.data;
      });
    };

    booking.cabinDetails = function (id) {
      return Request.get('account/bookings/cabin/' + id + '/').then(function (res) {
        return res.data;
      });
    };

    booking.generateLink = function (obj) {
      return '/' + Search.getShopKindName(obj.shopKind) + '/' + obj.shopLocationSlug + '/' + obj.shopSlug;
    };


    booking.confirmBooking = function (id) {
      return Request.put('account/bookings/' + id + '/convert/', { status: 20 }).then(function (res) {
        return res.data;
      });
    };

    booking.updateOrder = function (id, data) {
      var query = '';
      if (isAffiliate) query = '?is_affiliate=true';
      return Request.patch('account/bookings/' + id + '/' + query, data).then(function (res) {
        return res.data;
      });
    };

    return booking;
  });
